// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2IxKf","title":"AfterBackImages_title__2NpOX","images":"AfterBackImages_images__UrnUf"};